import { Search } from 'lucide-react';

const SearchPageSkeleton = () => {
  return (
    <div className="min-h-screen gradient-mesh pb-4 lg:pb-8">
      <header className="sticky top-0 z-50 glass-strong border-b" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="max-w-3xl mx-auto flex items-center justify-between h-14 md:h-16 px-4 md:px-6">
          <div className="h-6 w-32 rounded bg-secondary/50 shimmer-wrapper opacity-30" />
          <div className="h-8 w-8 rounded-full bg-secondary/50 shimmer-wrapper opacity-30" />
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-4 md:py-8 space-y-6 md:space-y-10">
        <div className="relative max-w-2xl mx-auto">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 md:h-5 md:w-5 text-muted-foreground opacity-50" />
          <div className="w-full h-12 md:h-14 rounded-2xl bg-card shadow-card border border-border/50 shimmer-wrapper opacity-20" />
        </div>

        {/* Empty State Match */}
        <div className="py-12 md:py-20 text-center">
          <div className="bg-primary/5 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
             <Search className="h-8 w-8 text-primary/40 opacity-50" />
          </div>
          <div className="h-5 w-48 mx-auto rounded bg-secondary/50 shimmer-wrapper opacity-40 mb-3" />
          <div className="h-3 w-64 mx-auto rounded bg-secondary/30 shimmer-wrapper opacity-30" />
        </div>
      </main>
    </div>
  );
};

export default SearchPageSkeleton;
